export const LocalStorageKeys = {
  SESSION_IS_DEV: '@Session.isDevelopment',
  THEME: '@Theme.colorScheme',
}
